import {
 CloseOutlined,
 HomeOutlined,
 MailOutlined,
 MenuOutlined,
 ReadOutlined,
 UserOutlined,
} from "@ant-design/icons";
import React, { useContext } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { UserContext } from "../../../../context/user";
import { PublicMenuContext } from "../../../../context/publicMenu";
import useScreenSize from "../../../../hooks/useScreenSize";
import "./PublicBottomNav.scss";

// MainNavbar.scss / StudentBottomNav (panel) ile aynı kırılım noktası olmalı,
// yoksa üst bar ile alt bar farklı genişliklerde farklı davranır.
// Panel tarafındaki StudentBottomNav.jsx da 992 kullanıyor; farklı bir
// eşik (önceden 1100) 992-1100px aralığında public ve panel tarafının
// farklı navigasyon görünmesine (biri alt menü, diğeri eski üst menü)
// yol açıyordu. Aynı eşiğe (992) sabitlendi.
const MOBILE_BREAKPOINT = 992;

const LEFT_ITEMS = [
 {
  key: "anasayfa",
  label: "Anasayfa",
  to: "/",
  icon: <HomeOutlined />,
  match: (path) => path === "/",
 },
 {
  key: "egitimler",
  label: "Eğitimler",
  to: "/egitimler/tumegitimler",
  icon: <ReadOutlined />,
  match: (path) => path.startsWith("/egitimler"),
 },
];

const NavItem = ({ item, path }) => {
 const active = item.match(path);
 return (
  <NavLink
   to={item.to}
   className={`public-bottom-nav__item${
    active ? " public-bottom-nav__item--active" : ""
   }`}
   aria-current={active ? "page" : undefined}
  >
   <span className="public-bottom-nav__icon" aria-hidden>
    {item.icon}
   </span>
   <span className="public-bottom-nav__label">{item.label}</span>
  </NavLink>
 );
};

const PublicBottomNav = () => {
 const [state] = useContext(UserContext);
 const { toggle, setToggle } = useContext(PublicMenuContext);
 const location = useLocation();
 const isMobile = useScreenSize(MOBILE_BREAKPOINT);

 if (!isMobile) return null;

 const rightItems = [
  {
   key: "iletisim",
   label: "İletişim",
   to: "/iletisim",
   icon: <MailOutlined />,
   match: (path) => path.startsWith("/iletisim"),
  },
  state.isLoggedIn
   ? {
      key: "panelim",
      label: "Panelim",
      to: "/panel/anasayfa",
      icon: <UserOutlined />,
      match: (path) => path.startsWith("/panel"),
     }
   : {
      key: "giris",
      label: "Giriş Yap",
      to: "/giris",
      icon: <UserOutlined />,
      match: (path) => path.startsWith("/giris"),
     },
 ];

 return (
  <nav className="public-bottom-nav" aria-label="Hızlı menü">
   <div className="public-bottom-nav__bar">
    <div className="public-bottom-nav__side">
     {LEFT_ITEMS.map((item) => (
      <NavItem key={item.key} item={item} path={location.pathname} />
     ))}
    </div>

    <button
     type="button"
     className={`public-bottom-nav__menu${
      toggle ? " public-bottom-nav__menu--open" : ""
     }`}
     aria-label={toggle ? "Menüyü kapat" : "Menüyü aç"}
     aria-expanded={toggle}
     onClick={() => setToggle(!toggle)}
    >
     {toggle ? <CloseOutlined /> : <MenuOutlined />}
    </button>

    <div className="public-bottom-nav__side">
     {rightItems.map((item) => (
      <NavItem key={item.key} item={item} path={location.pathname} />
     ))}
    </div>
   </div>
  </nav>
 );
};

export default PublicBottomNav;
